import { render, staticRenderFns } from "./InsightMetrics.vue?vue&type=template&id=adaf413c&scoped=true"
import script from "./InsightMetrics.vue?vue&type=script&lang=ts"
export * from "./InsightMetrics.vue?vue&type=script&lang=ts"
import style0 from "./InsightMetrics.vue?vue&type=style&index=0&id=adaf413c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adaf413c",
  null
  
)

export default component.exports